module.exports = __webpack_public_path__ + "img/170124.fd390b25.png";